import React, { useEffect } from "react";
import "./HomeSection.css";
import AOS from "aos";
import "aos/dist/aos.css";

// import img1 from "../../images/home_villa.jpg";
// import img2 from "../../images/top-villas-in-barbados.jpg";
// import img3 from "../../images/GHF_2615_original.jpg";
import herobg from "../../images/hero_bg.jpg";

// import client1 from "../../images/client1.jpg";
// import client2 from "../../images/client2.jpg";
// import client3 from "../../images/client3.jpg";
// import client4 from "../../images/client4.jpg";
// import client5 from "../../images/client5.jpg";

import { FaWhatsapp } from "react-icons/fa";

export default function HomeSection() {

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: true
    });
  }, []);

  return (
    <section id="home">

      <div className="hero-container">

        {/* LEFT SIDE — SINGLE PROPERTY IMAGE */}
        <div className="hero-images" data-aos="fade-right">
          <div className="hero-image-single">
            <img src={herobg} alt="Property" />
          </div>
        </div>


        {/* RIGHT SIDE — CONTENT */}
        <div className="hero-content" data-aos="fade-left">

          <h1 className="hero-title">
            O seu <span className="highlight">parceiro</span> na gestão profissional
            <br />
             de alojamento local.
            {/* <br /> */}
            
          </h1>

          <p className="hero-description">
            Ajudamos a explorar o potencial da sua propriedade
            <br />
            da forma mais eficiente.
          </p>

          <button
            className="hero-cta-button"
            onClick={() => {
              const el = document.getElementById("contacts");
              if (el) el.scrollIntoView({ behavior: "smooth" });
            }}
          >
            AGENDAR REUNIÃO
          </button>


          {/* CLIENT TRUST */}
          {/* <div className="hero-clients">

            <div className="hero-client-avatars">
              {[client1, client2, client3, client4, client5].map(
                (client, index) => (
                  <img
                    key={index}
                    src={client}
                    alt={`Client ${index + 1}`}
                    className="hero-client-avatar"
                  />
                )
              )}
            </div>

            <span className="hero-clients-label">
              Confiado por +56 proprietários
            </span>

          </div> */}

        </div>

      </div>


      {/* WHATSAPP FLOAT BUTTON */}
      <a
        href="https://wa.me/"
        target="_blank"
        rel="noopener noreferrer"
        className="hero-whatsapp-btn"
        aria-label="WhatsApp"
      >
        <FaWhatsapp size={28} />
      </a>

    </section>
  );
}